import React, { useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';

const OrderConfirmation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const payload = useMemo(() => {
    // Prefer navigation state, fall back to sessionStorage
    const fromState = location?.state || {};
    if (fromState && (fromState.idsOrder || fromState.payment_id || fromState.supplier_id)) {
      // persist for refreshes
      sessionStorage.setItem('order_confirmation', JSON.stringify(fromState));
      return fromState;
    }
    try {
      const raw = sessionStorage.getItem('order_confirmation');
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }, [location?.state]);

  const orderId = payload.idsOrder;
  const paymentId = payload.payment_id;
  const supplierId = payload.supplier_id;
  // const message = payload.message || t('Commande_reussie', { defaultValue: 'Order created successfully!' });

  useEffect(() => {
    if (!orderId && !paymentId) {
      // If landed without data, redirect back to shop
      // slight timeout to avoid flicker
      const tId = setTimeout(() => navigate('/Boutique'), 1200);
      return () => clearTimeout(tId);
    }
  }, [orderId, paymentId, navigate]);

  return (
    <AnimationRevealPage>
      <Light />

      {/* Right decorative stripe */}
      <div style={{ position: 'fixed', right: 0, top: 0, width: 12, height: '100vh', background: '#133b8c', zIndex: 0 }} />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="text-center py-5" style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <h3 className="mb-3" style={{ color: '#133b8c', fontWeight: 700 }}>{t('Confirmation', { defaultValue: 'Confirmation' })}</h3>

              {/* Check icon */}
              <div className="my-4 d-flex justify-content-center">
                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#133b8c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>

              <h5 style={{ color: '#133b8c', fontWeight: 600 }} className="mb-4">{t('Successful', { defaultValue: 'Commande réussie !' })}</h5>

              <p className="mb-1" style={{ color: '#374151' }}>
                {t('Votre_numero_commande_est', { defaultValue: 'Votre numéro de commande est' })}
                {" "}
                <span style={{ color: '#133b8c', fontWeight: 700 }}>#{orderId || '—'}</span>
              </p>
            

              {/* Optional technical refs */}
             

              <p className="mt-4 mb-5" style={{ color: '#111827' }}>{t('Merci_pour_votre_achat', { defaultValue: 'Merci pour votre achat' })}</p>

              <div className="d-grid">
                <Link to="/Boutique" className="btn" style={{ background: '#133b8c', color: '#fff', borderRadius: 9999, padding: '12px 16px', fontWeight: 600 }}>
                  {t('Continuer_les_achats', { defaultValue: 'Continuer vos achats' })}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default OrderConfirmation;
